module.exports = "/images/agent-onboarding-1.png?4b26d18b092f3da550db1c9272abfff1";